export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6378.2c209e41.jpg";